import React from 'react';
import { useAuth0 } from "@auth0/auth0-react";
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import ClipLoader from 'react-spinners/ClipLoader';
import Dashboard from './Components/Dashboard';
import LandingPage from './Components/LandingPage';
import BlogList from "./Components/BlogList";
import BlogPost from "./Components/BlogPost";
import ArticleSubmissionForm from './Components/ArticleSubmissionForm';
import Service from "./Components/Service"

//changes to auth
const App = () => {
  const { isLoading, isAuthenticated } = useAuth0();

  if (isLoading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh'
      }}>
        <ClipLoader color="#3498db" loading={isLoading} />
      </div>
    );
  }

  return (
    <Router>
      <div className="bg-white">
        <Routes>
          {/* <Route path="/login" element={isAuthenticated ? <Navigate to="/dashboard" /> : <Login />} /> */}
          <Route path="/dashboard/*" element={isAuthenticated ? <Dashboard /> : <Navigate to="/" />} />
          <Route path="/" element={isAuthenticated ? <Navigate to="/dashboard" /> : <LandingPage />} />
          <Route path="/blog" element={<BlogList />} />
          <Route path="/pr-as-a-service" element={<Service />} />

          <Route path="/query" element={<ArticleSubmissionForm />} />
          {/* Blog Post by Slug */}
          <Route path="/blog/:slug" element={<BlogPost />} />
        </Routes>
      </div>
    </Router>
  );
};

export default App;